var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":"#fafafa"}},[_vm._v("fa-book-open")])
}
var staticRenderFns = []

export { render, staticRenderFns }